// medalsLogic.js — logique seule, sans base64
// Les chemins images pointent vers /public/medals/

const MEDAL_IMGS = {
  bronze:    "/medals/medal_bronze.png",
  argent:    "/medals/medal_silver.png",
  or:        "/medals/medal_gold.png",
  diamant:   "/medals/medal_diamond.png",
  collector: "/medals/medal_collector.png",
};

const MEDALS_DEF_LOGIC = [
  { label:"Bronze",              level:10, imgKey:"bronze",    img:MEDAL_IMGS.bronze    },
  { label:"Argent",              level:20, imgKey:"argent",    img:MEDAL_IMGS.argent    },
  { label:"Or",                  level:30, imgKey:"or",        img:MEDAL_IMGS.or        },
  { label:"Diamant",             level:40, imgKey:"diamant",   img:MEDAL_IMGS.diamant   },
  { label:"Calestan Collector",  level:50, imgKey:"collector", img:MEDAL_IMGS.collector },
];

function getMedal(level) {
  let earned = null;
  for(const m of MEDALS_DEF_LOGIC) { if(level >= m.level) earned = m; }
  return earned;
}

function getNextMedal(level) {
  return MEDALS_DEF_LOGIC.find(m => m.level > level) || null;
}

function getLevelsUntilNext(level) {
  const next = getNextMedal(level);
  return next ? next.level - level : 0;
}

// Alias pour compatibilité avec les anciens appels (sessions → ignoré, on passe level)
function getSessionsUntilNext(level) {
  return getLevelsUntilNext(level);
}

export { MEDALS_DEF_LOGIC, getMedal, getNextMedal, getNextMedal as getNextMedalByLevel, getLevelsUntilNext, getSessionsUntilNext };
